import { render, staticRenderFns } from "./DayView.vue?vue&type=template&id=19847b85&scoped=true"
import script from "./DayView.vue?vue&type=script&lang=js"
export * from "./DayView.vue?vue&type=script&lang=js"
import style0 from "./DayView.vue?vue&type=style&index=0&id=19847b85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19847b85",
  null
  
)

export default component.exports